"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var QuestionAnswer_exports = {};
__export(QuestionAnswer_exports, {
  default: () => QuestionAnswer_default
});
module.exports = __toCommonJS(QuestionAnswer_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.2578 5.75781H15.7539V12.4961H6.00781V14C6.00781 14.2083 6.07943 14.3841 6.22266 14.5273C6.36589 14.6706 6.54167 14.7422 6.75 14.7422H14.9922L18 17.75V6.5C18 6.29167 17.9219 6.11589 17.7656 5.97266C17.6224 5.82943 17.4531 5.75781 17.2578 5.75781ZM14.25 10.25V3.49219C14.25 3.29688 14.1719 3.1276 14.0156 2.98438C13.8724 2.82812 13.7031 2.75 13.5078 2.75H3.74219C3.54688 2.75 3.37109 2.82812 3.21484 2.98438C3.07161 3.1276 3 3.29688 3 3.49219V14L6.00781 10.9922H13.5078C13.7031 10.9922 13.8724 10.9206 14.0156 10.7773C14.1719 10.6341 14.25 10.4583 14.25 10.25Z",
      fill: "currentColor"
    }
  )
);
const SvgQuestionAnswer = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var QuestionAnswer_default = SvgQuestionAnswer;
